// extracted by mini-css-extract-plugin
module.exports = {"Faq":"Faq_Faq__Gsf66","paragraph":"Faq_paragraph__1KJDQ","list":"Faq_list__Rx1_A","indicator":"Faq_indicator__QhLL6","answer":"Faq_answer__E9tmp"};